import { Inline, Stack, Text, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';
import { screenReadersOnlyStyles } from '../../../../../utils/styleUtils';

interface SelectedTripFarePriceProps {
  selectedTripPricePerAdult: number;
}

const pricePerPersonSection = css`
  border-top: 1px solid ${vars.colors.divider};
  padding-top: 16px;
`;
const SelectedTripFarePrice = ({ selectedTripPricePerAdult }: SelectedTripFarePriceProps) => {
  const { t } = useTranslation();
  const formattedPrice = priceUtils.formatPrice(selectedTripPricePerAdult);

  return (
    <Inline
      align="end"
      className={pricePerPersonSection}
      data-testid="trip-fare-price-selected-trip"
    >
      <Stack align="end" spacing={0}>
        <Text aria-hidden as="span" variant="24-emphasized">
          {formattedPrice}
        </Text>
        <Text aria-hidden>{t('Result.PricePerAdult.Text')}</Text>
        <Text className={screenReadersOnlyStyles}>
          {`${priceUtils.replaceWithCurrencyName(formattedPrice)}  ${t('Price.Per.Adult')}`}
        </Text>
      </Stack>
    </Inline>
  );
};

export default SelectedTripFarePrice;
